import { createStore, combineReducers } from "redux";
import { useSelector as useReduxSelector, TypedUseSelectorHook } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { mainReducer } from "../services/main/main.reducer";
import { userReducer } from "../reducers/user.reducer";
import { settingsReducer } from "../services/main/settings.reducer";
import { employeeReducer } from "../reducers/employee.reducer";
import { systemMgmtReducer } from "../reducers/systemMgmt.reducer";
import { groupsReducer } from "../reducers/groups.reducer";
import { trainingReducer } from "../reducers/training.reducer";
import { documentReducer } from "../reducers/document.reducer";
import { configReducer } from "../reducers/config.reducer";
import { lookupDataReducer } from "../reducers/lookupData.reducer";
import { documentTemplatesReducer } from "../reducers/documentTemplates.reducer";
import { adminUserReducer } from "../reducers/admin-user.reducer";
import { chatReducer } from "../reducers/chat.reducer";

const rootReducer = combineReducers({
  main: mainReducer,
  user: userReducer,
  employee: employeeReducer,
  systemMgmt: systemMgmtReducer,
  groups: groupsReducer,
  settings: settingsReducer,
  training: trainingReducer,
  document: documentReducer,
  configs: configReducer,
  lookupData: lookupDataReducer,
  documentTempaltes: documentTemplatesReducer,
  userAdmin: adminUserReducer,
  chat: chatReducer,
});

// Redux Persist Config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
  blacklist: [],
};

// Redux Persist Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store
export const store = createStore(persistedReducer, composeWithDevTools());

// Redux Persist Persister
export const persistor = persistStore(store);
export const useSelector: TypedUseSelectorHook<ReturnType<typeof rootReducer>> = useReduxSelector;

export type TStoreAction = {
  type: string;
  [name: string]: any;
};
